import { a as r } from "../internals/array-buffer-view-core.js";
import { t } from "../internals/typed-array-constructors-require-wrappers.js";
var a = r.aTypedArrayConstructor;
(0, r.exportTypedArrayStaticMethod)("of", function () {
  for (var r = 0, t = arguments.length, e = new (a(this))(t); t > r;) e[r] = arguments[r++];
  return e;
}, t);